import { useEffect, useState } from 'react';
import { Container, Text } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../../../hooks';
import { boostedJackpotDateHelper } from '../../../../../helpers';

type BoostedJackpotWheelTimerProps = {
  x?: number,
  y?: number,
};

export const BoostedJackpotWheelTimer: React.FC<BoostedJackpotWheelTimerProps> = observer(({
  x = 0,
  y = 0,
}) => {
  const { boostedJackpotStore } = useStore();
  const [tick, setTick] = useState<number>(0);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setTick((prev) => prev + 1);
    }, 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  const { minutes, seconds } = boostedJackpotDateHelper((boostedJackpotStore.wheelTriggerExpireDate || boostedJackpotStore.wheelInfo?.wheelExpireDate) ?? '0');
  const timerText = `${minutes}:${seconds}`;

  return (
    <Container x={x} y={y} {...({ name: 'BoostedJackpotWheelTimer' } as any)}>
      <Text
        x={0}
        y={0}
        anchor={0.5}
        text={timerText}
        resolution={2}
        style={{
          fontSize: 36,
          align: 'center',
          fill: '#FFFFFF',
          fontWeight: '700',
          fontFamily: 'Impact',
          letterSpacing: 4,
        } as any}
      />
    </Container>
  );
});